import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-dialog-solution-scenario',
  templateUrl: './dialog-solution-scenario.component.html',
  styleUrls: ['./dialog-solution-scenario.component.scss']
})
export class DialogSolutionScenarioComponent {
  filteredProjects?: any[];
  form!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogSolutionScenarioComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.filteredProjects = [...this.data.projects];

    this.form = new FormGroup({
      selectedSolution: new FormControl('', Validators.required)
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  search(target: any) {
    let filteredProjectsData: any[] = [];

    if (target?.value?.length?.length < 2) {
      this.filteredProjects = [...this.data.projects];
      return;
    }

    const filteredProjectsParents = [
      ...this.data.projects.filter(
        (p: { displayName: string; solutions: any[] }) => p.displayName.toLowerCase().includes(target?.value.toLowerCase()) || p.solutions.some((s: { displayName: string }) => s.displayName.toLowerCase().includes(target?.value.toLowerCase()))
      )
    ];

    for (const project of filteredProjectsParents) {
      if (!project.displayName.toLowerCase().includes(target?.value.toLowerCase())) {
        let filteredSolutions = project.solutions.filter((v: { displayName: string }) => v.displayName.toLowerCase().includes(target?.value?.toLowerCase()));

        const projectItem = {
          displayName: project.displayName,
          solutions: filteredSolutions
        };

        filteredProjectsData.push(projectItem);
      } else {
        filteredProjectsData.push(project);
      }
    }

    this.filteredProjects = filteredProjectsData;
  }
}
